import { render, staticRenderFns } from "./AnchorImages.vue?vue&type=template&id=487c5f76&scoped=true"
import script from "./AnchorImages.vue?vue&type=script&lang=js"
export * from "./AnchorImages.vue?vue&type=script&lang=js"
import style0 from "./AnchorImages.vue?vue&type=style&index=0&id=487c5f76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c5f76",
  null
  
)

export default component.exports